// 用于将数组序列化成以id为键的对象
export const mapSerialize = function(arr=[],key='id'){
    const map={};
    arr.forEach(item=>{
        map[item[key]]=item;
    })
    return map;
}

// 将一个对象扁平化为对象数组 （将键去掉）反序列化
export const mapDeserialize=function(obj={}){
    const arr=[];
    Object.keys(obj).forEach(key=>{
        arr.push(obj[key]);
    })
    return arr;
}
export default mapSerialize;


// 对比两个Object数组 求出差集
export const diffSet=function(obj1={},obj2={}){
    let keys1=Object.keys(obj1);
    let keys2=Object.keys(obj2);
    // 如果一方是空 则差集肯定是另一方
    if(!keys1.length)
        return obj2;
    if(!keys2.length)
        return obj1

    
    const diff={};
    keys1.forEach(key=>{
        if(!obj2[key])
            diff[key]=obj1[key];
    });
    return diff;
}